import { Row, Col, Typography, Empty, Spin } from "antd";
import AdvertCard from "../../../Listings/Components/AdvertCard";
import usePersonnelAdvertService from "../../../../services/usePersonnelAdvertService";
import useIsSmallScreen from "../../../../hooks/useIsSmallScreen";
import JobCarousel from "../../../Home/Componenets/JobCarousel";

const { Title } = Typography;

const SimilarJobs = ({ advertId, headerText }) => {
  const isSmallScreen = useIsSmallScreen();
  const { useGetSimilarAdverts } = usePersonnelAdvertService();
  const { data: similarAdvertsResponse, isLoading: isSimilarAdvertsLoading } =
    useGetSimilarAdverts(advertId);

  const similarAdverts = similarAdvertsResponse?.data?.data || [];
  console.log("similar adverts", similarAdverts);

  if (isSimilarAdvertsLoading) {
    return (
      <div style={{ padding: "40px 0", textAlign: "center" }}>
        <Spin size="large" tip="Yükleniyor..." />
      </div>
    );
  }

  return (
    <div style={{ padding: isSmallScreen ? "0 10px" : 0 }}>
      <Title
        level={2}
        style={{
          textAlign: "start",
          marginBottom: "24px",
          paddingLeft: isSmallScreen ? 15 : 50,
        }}>
        Benzer İlanlar
      </Title>

      {similarAdverts.length === 0 ? (
        <div style={{ padding: "40px 0", textAlign: "center" }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span style={{ fontSize: "16px", color: "#666" }}>
                Benzer ilan bulamadık
              </span>
            }
          />
        </div>
      ) : (
        <JobCarousel adverts={similarAdverts} headerText={headerText} />
        // <Row gutter={[16, 16]}>
        //   {similarAdverts.map((advert) => (
        //     <Col key={advert.id} xs={24} sm={24} md={12}>
        //       <AdvertCard advert={advert} />
        //     </Col>
        //   ))}
        // </Row>
      )}
    </div>
  );
};

export default SimilarJobs;
